export const HEAD_ADMIN_ROLE = 'site_owner';

export function isHeadAdmin(role) {
  return role === HEAD_ADMIN_ROLE;
}

/** site_owner is hardcoded to ['all'] and bypasses every permission check */
export function getEffectivePermissions(role, permissions) {
  if (isHeadAdmin(role)) return ['all'];
  return permissions || [];
}

export function hasPermission(permissions, role, permission) {
  if (isHeadAdmin(role)) return true;
  const perms = getEffectivePermissions(role, permissions);
  return perms.includes('all') || perms.includes(permission);
}

export function canAccessAdmin(permissions, role) {
  return hasPermission(permissions, role, 'view_admin_panel');
}

export function canViewSensitiveUserInfo(permissions, role) {
  return hasPermission(permissions, role, 'view_sensitive_user_info');
}

export function canAccessClubManager(permissions, role) {
  return hasPermission(permissions, role, 'admin_clubs')
    || hasPermission(permissions, role, 'manage_clubs')
    || hasPermission(permissions, role, 'manage_own_club')
    || hasPermission(permissions, role, 'moderate_clubs')
    || hasPermission(permissions, role, 'manage_club_members');
}

/** @deprecated use canAccessClubManager */
export const canAccessClubEditor = canAccessClubManager;

export function canAdminAllClubs(permissions, role) {
  return hasPermission(permissions, role, 'admin_clubs')
    || hasPermission(permissions, role, 'manage_clubs');
}

export function canChangeGlobalSettings(permissions, role) {
  return hasPermission(permissions, role, 'change_global_settings');
}